import styled from "styled-components";
import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { Tabs } from "@material-ui/core";
import { Height } from "@material-ui/icons";

export const PropertyDetailsStyles: any = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1,
    },
    marginTop: {
        marginTop: "40px",
    },
    tabsContainer: {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        paddingLeft: "24px",
        paddingRight: "24px",
    },
    tabsWidth: {
        width: "100%",
        maxWidth: "1040px",
        "& button": {
            boxShadow: "inset 0px -3px 3px #00000029",
            border: "1px solid #3C3C3B",
            borderRadius: "10px 10px 0px 0px !important",
            minWidth: "300px",
            borderBottom: "none",
            fontSize: "12px",
            lineHeight: "15px",
            letterSpacing: "-0.18px",
            color: "#3C3C3B",
            fontFamily: "'Inter', sans-serif",
            textTransform: "capitalize",
            fontWeight: "400 !important",
        },
        [theme.breakpoints.down("sm")]: {
            padding: "10px 0px 0 0px",

            minHeight: "auto !important",
            "& button": {
                minHeight: "34px",
                height: "34px !important",

                minWidth: "170px",
            },
        },
    },
    [theme.breakpoints.down("sm")]: {
        tabsWidth: {},
    },
    detailCard: {
        background: "#3C3C3B",
        minHeight: "calc(100% - 100px)",
        [theme.breakpoints.down("sm")]: {
            minHeight: "calc(100% - 50px)",
        },
        // minHeight: "80vh",

        // [theme.breakpoints.down("sm")]: {
        //     flexDirection: "column-reverse",
        // },
    },
    detailCardPlot: {
        "&> .plotPropertyImages": {
            [theme.breakpoints.up("md")]: {
                position: "sticky",
                top: "0 ",
            },
        },
        [theme.breakpoints.up("md")]: {
            height: "calc(100vh - 130px)",
            overflow: "auto",
        },
    },
    imageCard: {
        width: "533px",
        height: "297px",
    },
    imageCardSubView: {},
    imageCardItems: {
        marginTop: "12px",
        overflow: "auto",
        "&::-webkit-scrollbar": {
            width: "10px",
            height: "10px",
        },

        /* Track */
        "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
        },

        /* Handle */
        "&::-webkit-scrollbar-thumb": {
            background: "#888",
        },

        /* Handle on hover */
        "&::-webkit-scrollbar-thumb:hover": {
            background: "#555",
        },
    },
    propertyDetails: {
        padding: "30px 60px",
        // minHeight: "440px",
        alignItems: "center",

        // "& > div": {
        //     height: "100%",
        // },

        [theme.breakpoints.up("md")]: {
            height: "calc(100vh - 136px)",
            overflow: "auto",
        },
        [theme.breakpoints.down("sm")]: {
            padding: "10px 0px",
        },
    },
    dimensionsList: {
        marginTop: "40px",
        [theme.breakpoints.down("sm")]: {
            marginTop: "20px",
            padding: "0 30px",
        },
    },
    dimensionsListTitle: {
        fontSize: "14px",
        lineHeight: "17px",
        fontWeight: 400,
        letterSpacing: "-0.35px",
        color: "#FFFFFF",
    },
    dimensionsListBlock: {
        marginTop: "14px",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "10px 60px",
        maxWidth: "500px",
        width: "100%",
    },
    dimensionsListItem: {
        "& p": {
            fontSize: "12px",
            lineHeight: "15px",
            fontWeight: 400,
            letterSpacing: "-0.3px",
            color: "#FFFFFF",
            fontFamily: "'Inter', sans-serif",
            "& strong": {
                minWidth: "105px",
                display: "inline-block",
            },
            [theme.breakpoints.down("sm")]: {
                fontSize: "10px",
                lineHeight: "12px",
            },
        },
    },
    floorplanImage: {
        marginTop: "40px",
    },
    floorplanTitle: {
        fontSize: "14px",
        lineHeight: "normal",
        fontWeight: 400,
        letterSpacing: "-0.35px",
        color: "#FFFFFF",
        fontFamily: "'Inter', sans-serif",
    },
    floorplanImgBlock: {
        marginTop: "20px",
    },
    [theme.breakpoints.down("sm")]: {
        floorplanTitle: {
            padding: "0 30px",
        },
        floorplanImage: {
            marginTop: "20px !important",
        },
    },
}));

export const TabsCustom: any = styled(Tabs)`
    .MuiButtonBase-root {
        color: #3c3c3b;
        opacity: 0.8;
        font-weight: bold;
        font-size: 14px;
        width: 147px;
        height: 53px;
        margin: 0;
        border-radius: 0px;
        z-index: 1;

        hover {
            background: #d0d0d0 0% 0% no-repeat;
        }
    }

    .MuiButtonBase-root.Mui-selected {
        color: #fff;
        background: #d0d0d0 0% 0% no-repeat;
        opacity: 1;
        background: #3c3c3b 0% 0% no-repeat;
        /* box-shadow: 0px 0px 2px 3px #00000029; */
        z-index: 2;
        border-bottom: none;

        hover {
            background: #c3c3b 0% 0% no-repeat;
        }
    }
`;
